<template>
  <v-layout>
    <v-card class="bordered-card" style="height: 100%;">
      <v-toolbar class="grey lighten-4 elevation-0">
        <v-toolbar-title class="grey--text text-underline text--darken-4">
          Add New Tutorial
        </v-toolbar-title>
      </v-toolbar>
      <v-card-text style="">
        <v-layout>
          <v-flex xs12 md12>
            <input type="text" class="form-control" placeholder="Enter Question here" style="height: 40px;" v-model="tutorial.question">
            <vue-editor placeholder="Enter Answer here" v-model="tutorial.answer" :editorToolbar="customToolbar"></vue-editor>
            <v-flex xs6>
              <span style="margin-top: 18px;font-size: 18px;display:block;">Media Type</span>
              <v-radio-group v-model="mediaType" row>
                <v-radio label="Image" value="image"></v-radio>
                <v-radio label="Video" value="video"></v-radio>
                <v-radio label="No Media" value=""></v-radio>
              </v-radio-group>
            </v-flex>
            <v-card v-if="mediaType === 'image'" class="bordered-card mt-3">
              <v-toolbar dense class="grey lighten-4 elevation-0">
                <v-toolbar-title dense class="grey--text text-underline text--darken-4">
                  Featured Image (<strong>Recommendation: No larger than 500 * 300</strong>)
                </v-toolbar-title>
              </v-toolbar>
              <v-card-text>
                <v-card v-if="tutorialPhotoFile!==''" class="mt-0 pt-0">
                  <div style="width:100%">
                    <v-btn icon class="" id='close' @click.prevent="cancelResourcePhoto()">
                      <v-icon style="font-size: 15px;">close</v-icon>
                    </v-btn>
                    <img :src="tutorialPhotoFileURL" id="faqActivity" style="max-width:100%;">
                  </div>
                </v-card>
                <v-btn v-else @click="tutorialPhotoUploaded = true">
                  <v-icon medium>insert_photo</v-icon>
                  Add Media
                </v-btn>

                <file-upload :trigger="tutorialPhotoUploaded" @cancel="tutorialPhotoUploaded=false;tutorialPhotoFile=''"
                  :formats="['jpeg','png','jpg']" v-model="tutorialPhotoFile" @confirm="showTutorialPhoto()"></file-upload>
              </v-card-text>
            </v-card>
            <v-card v-if="mediaType === 'video'" class="bordered-card mt-3">
              <v-toolbar dense class="grey lighten-4 elevation-0">
                <v-toolbar-title dense class="grey--text text-underline text--darken-4">
                  Featured Video
                </v-toolbar-title>
              </v-toolbar>
              <v-card-text>
                <input type="text" class="form-control" placeholder="Video link e.g youtube or vimeo" style="height: 40px;"
                  v-model="videoLink">
              </v-card-text>
            </v-card>
            <v-layout>
              <v-btn style="margin:10px 0px;" class="primary" @click.prevent="addResource()" :disabled="this.$store.getters.getLoading && tutorialProcess" :loading="this.$store.getters.getLoading && tutorialProcess">
                Save
                <span slot="loader" class="custom-loader">
                  <v-icon dark>cached</v-icon>
                </span>
              </v-btn>
              <v-btn style="margin:10px 10px;" class="secondary" @click.prevent="goBack" :disabled="this.$store.getters.getLoading && tutorialProcess">
                Cancel
              </v-btn>
            </v-layout>
          </v-flex>
        </v-layout>

      </v-card-text>

    </v-card>
  </v-layout>
</template>
<script>
import { VueEditor } from 'vue2-editor'
import AdminSideBarMenu from '../Components/AdminSideBar.vue'
import FileUpload from '@/components/FileUploadComponent.vue'
import PageFooter from '../Components/PageFooter.vue'
export default {
  components: {
    AdminSideBarMenu,
    PageFooter,
    FileUpload,
    VueEditor
  },
  created () {
    this.$store.dispatch('getTutorials')
  },
  async mounted () {
    this.mode = this.$router.currentRoute.query.mode
    let postId = this.$router.currentRoute.query.id
    if (!this.mode || !postId) {
      this.mode = 'add'
    } else {
      let snapshot = await this.$firebase
        .database()
        .ref('tutorials')
        .child(postId)
        .once('value')
      if (!snapshot.val()) {
        this.mode = 'add'
      } else {
        this.tutorial = snapshot.val()
        if (this.tutorial.mediaType === 'video') {
          this.mediaType = this.tutorial.mediaType
          this.videoLink = this.tutorial.media.link
        } else if (this.tutorial.mediaType === 'image') {
          this.mediaType = 'image'
          this.tutorialPhotoFileURL = this.tutorial.media
          this.tutorialPhotoFile = this.tutorial.media
        } else {
          this.mediaType = ''
        }
      }
    }
    const payload = {
      meta: {
        h1: 'Admin Tutorials',
        title: `Admin Tutorials - ${this.mode === 'add' ? 'New' : 'Edit'} Tutorial`,
        requiresAuth: true
      }
    }
    document.title = payload.meta.title
    this.$store.commit('setHeaderInfo', payload)
  },
  computed: {
    user () {
      return this.$store.getters.getUserDetails
    },
    styles () {
      return this.$store.getters.getStyles
    },
    tutorials () {
      return this.$store.getters.tutorials.sort((a, b) => a.order - b.order)
    },
    tutorialProcess () {
      return this.$store.getters.getProcess === 'FAQ Submit'
    }
  },
  data: () => ({
    mode: 'add',
    videoLink: '',
    mediaType: '',
    customToolbar: [
      [{ header: [false, 1, 2, 3, 4, 5, 6] }],

      [{ size: ['small', false, 'large', 'huge'] }],

      ['bold', 'italic', 'underline', 'strike'],

      [
        { align: '' },
        { align: 'center' },
        { align: 'right' },
        { align: 'justify' }
      ],

      [{ header: 1 }, { header: 2 }],

      ['blockquote', 'code-block'],

      [{ list: 'ordered' }, { list: 'bullet' }, { list: 'check' }],

      [{ script: 'sub' }, { script: 'super' }],

      [{ indent: '-1' }, { indent: '+1' }],

      [{ color: [] }, { background: [] }],

      ['link', 'formula'],

      [{ direction: 'rtl' }],
      ['clean']
    ],
    tutorial: {
      question: '',
      answer: '',
      submitby: '',
      featured: false,
      media: '',
      mediaType: ''
    },
    tutorialPhotoUploaded: false,
    tutorialPhotoFile: '',
    tutorialPhotoFileName: '',
    tutorialPhotoFileURL: ''
  }),
  methods: {
    validateVideoUrl (text) {
      var type = null
      var embedUrl = null
      text.match(
        /(http:|https:|)\/\/(player.|www.)?(vimeo\.com|youtu(be\.com|\.be|be\.googleapis\.com))\/(video\/|embed\/|watch\?v=|v\/)?([A-Za-z0-9._%-]*)(\&\S+)?/ // eslint-disable-line
      )

      if (RegExp.$3.indexOf('youtu') > -1) {
        type = 'youtube'
        embedUrl = `https://www.youtube.com/embed/${RegExp.$6}?autoplay=0`
      } else if (RegExp.$3.indexOf('vimeo') > -1) {
        type = 'vimeo'
        embedUrl = `https://player.vimeo.com/video/${RegExp.$6}?color=ef0000`
      }

      if (!type) {
        return undefined
      }
      return {
        type: type,
        link: text,
        id: RegExp.$6,
        embedUrl
      }
    },
    goBack () {
      this.$router.back()
    },
    onDismiss () {
      this.$store.dispatch('setError', null)
      this.$store.dispatch('setProcess', 'null')
    },
    triggerDrawer () {
      this.drawer = !this.drawer
    },
    addResource () {
      if (this.tutorial.question === '') {
        return this.showError('Please add a question')
      } else if (this.tutorial.answer === '') {
        return this.showError('Please enter an answer')
      } else if (this.mediaType) {
        if (
          this.mediaType === 'image' &&
          !this.tutorialPhotoFile &&
          !this.tutorialPhotoFile.length
        ) {
          return this.showError('Please add featured media image')
        }
        if (this.mediaType === 'video' && !this.videoLink.length) {
          return this.showError('Please add featured video link')
        } else if (
          this.mediaType === 'video' &&
          this.videoLink.length &&
          !this.validateVideoUrl(this.videoLink).id
        ) {
          return this.showError('Please add a valid video link')
        }
      }
      let payload = {
        tutorial: this.tutorial,
        mode: this.mode,
        flags: {}
      }
      if (this.mediaType === 'image') {
        payload.tutorial.mediaType = 'image'
        payload.tutorial.media = this.tutorialPhotoFile
        payload.flags.photoUploaded = this.tutorialPhotoFileName
        this.cancelResourcePhoto()
      } else if (this.mediaType === 'video') {
        payload.tutorial.mediaType = 'video'
        payload.tutorial.media = this.validateVideoUrl(this.videoLink)
      } else if (this.mediaType === '') {
        payload.tutorial.mediaType = ''
        payload.tutorial.media = ''
      }
      payload.tutorial.order = this.tutorials.length ? payload.tutorial.order ? payload.tutorial.order : this.tutorials[this.tutorials.length - 1].order + 1 : 1
      this.$store.dispatch('submitTutorial', payload).then(() => {
        this.tutorial = {
          question: '',
          answer: '',
          submitby: '',
          featured: false,
          media: '',
          mediaType: ''
        }
        this.$router.back()
      })
    },
    showError (error) {
      let snackbar = {
        active: true,
        text: error
      }
      this.$store.dispatch('triggerSnackbar', snackbar)
      setTimeout(() => {
        let snackbar = {
          active: false,
          text: ''
        }

        this.$store.dispatch('triggerSnackbar', snackbar)
      }, 2000)
    },
    cancelResourcePhoto () {
      this.tutorialPhotoUploaded = false
      this.tutorialPhotoFile = ''
      this.tutorialPhotoFileName = ''
      this.tutorialPhotoFileURL = ''
    },
    showTutorialPhoto () {
      if (
        FileReader &&
        this.tutorialPhotoFile &&
        this.tutorialPhotoFile.length
      ) {
        var fr = new FileReader()
        fr.onload = function () {
          this.tutorialPhotoFileURL = fr.result
          document.getElementById('faqActivity').src = fr.result
        }
        fr.readAsDataURL(this.tutorialPhotoFile[0])
      } else {
      }
      this.tutorialPhotoFileName = this.tutorialPhotoFile[0].name
      this.tutorialPhotoUploaded = false
    }
  }
}
</script>
<style scoped>
.datatable th.column.text-xs-left {
  text-align: center !important;
}
.my_white ul li a {
  color: white !important;
}
tr td:nth-child(2) {
  width: 21% !important;
}

.input-group--select .input-group__append-icon {
  color: #ffff61 !important;
}
.form-control {
  display: block;
  width: 100%;

  padding: 6px 12px;
  font-size: 16px;
  line-height: 1.42857143;
  color: #000;
  background-color: #fff;
  background-image: none;
  margin-bottom: 10px;
  border-radius: 4px;
  border: 1px solid rgba(0, 0, 0, 0.2);
  -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);
  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);
  -webkit-transition: border-color ease-in-out 0.15s,
    -webkit-box-shadow ease-in-out 0.15s;
  transition: border-color ease-in-out 0.15s,
    -webkit-box-shadow ease-in-out 0.15s;
  transition: border-color ease-in-out 0.15s, box-shadow ease-in-out 0.15s;
  transition: border-color ease-in-out 0.15s, box-shadow ease-in-out 0.15s,
    -webkit-box-shadow ease-in-out 0.15s;
}
.form-control::placeholder {
  /* Chrome, Firefox, Opera, Safari 10.1+ */
  color: #000;
  opacity: 1; /* Firefox */
}

.form-control:-ms-input-placeholder {
  /* Internet Explorer 10-11 */
  color: #000;
}

.form-control::-ms-input-placeholder {
  /* Microsoft Edge */
  color: #000;
}
.input-group--text-field label {
  position: absolute;
  top: 6px !important;
  left: 13px !important;
}
.input-group:not(.input-group--error) label {
  color: #fff !important;
}

#faqActivity {
  border-style: dotted;
  border-width: 2px;
  height: 100px;
  padding: 15px;
  margin: 5px;
  border-color: gainsboro;
}
#close {
  float: left;
  display: inline-block;
  padding: 5px 5px;
}
</style>



// WEBPACK FOOTER //
// NewTutorial.vue?6e6bc874